<template>
    <div>
<!--        <Modal v-model="mainTable.sarchCardShow"
            title="搜索条件"
            :width="1000"
            footer-hide>
            <search-card :form="mainTable.searchForm"
                :table-load-event="getSaleStatList"
                :table-search="mainTable.tableSearch" />
        </Modal> -->

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">内部部门调拨统计</span>
                        <span style="margin-left: 20px">统计时间:</span>
                        <DatePicker type="daterange"
                            v-model="selectDates"
                            size="small"
                            transfer
                            placement="bottom-end"
                            placeholder="选择期初和期末时间"
                            style="margin-left: 4px; width: 200px"
                            @on-change="onDateChange"></DatePicker>
                    </div>
                    <div class="right-bar">
                        <Button type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            @click="onExport()">导出</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <Tabs :animated="false"
                    v-model="currentTab">
                    <TabPane label="公司内部项目之间调拨"
                        name="same">
                        <stand-pagination-table v-show="currentTab === 'same'"
                            :columns="mainTable.columns"
                            :data="mainTable.sameCompanyData"
                            :loading="mainTable.loading"
                            :table-search="mainTable.tableSearch"
                            :table-load-event="getSaleStatList"
                            :showPage="false" />
                    </TabPane>
                    <TabPane label="公司项目与公司项目之间调拨"
                        name="diff">
                        <stand-pagination-table v-show="currentTab === 'diff'"
                            :columns="mainTable.columns"
                            :data="mainTable.diffCompanyData"
                            :loading="mainTable.loading"
                            :table-search="mainTable.tableSearch"
                            :table-load-event="getSaleStatList"
                            :showPage="false" />
                    </TabPane>
                </Tabs>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import {
    numberToFixed,
    number2ThousandsFormat
} from "@/components/number-input/display-format";
import { getThisMonthStart, getTodayDateString } from "@/libs/logic";
import { getCompanyCombineSaleStat } from "@/api/modules/sale-management/sale-stat";
import { DOWNLOAD_SERVER } from "@/api/modules/files";

export default {
    name: "sale-company-stat-list",
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            selectDates: [],
            currentTab: 'same',
            mainTable: {
                columns: [
                    {
                        title: "调出项目编码",
                        key: "sellerCode",
                        align: "left"
                    },
                    {
                        title: "调出项部门",
                        key: "sellerName",
                        align: "left"
                    },
                    {
                        title: "调出公司",
                        key: "sellerCompany",
                        align: "left"
                    },
                    {
                        title: "调入项目编码",
                        key: "buyerCode",
                        align: "left"
                    },
                    {
                        title: "调入项部门",
                        key: "buyerName",
                        align: "left"
                    },
                    {
                        title: "调入公司",
                        key: "buyerCompany",
                        align: "left"
                    },

                    {
                        title: "调动金额",
                        key: "saleValue",
                        align: "right",
                        render: (h, params) => {
                            const saleValue = params.row.saleValue
                                ? params.row.saleValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(saleValue, 2, "￥")
                                )
                            ]);
                        }
                    },
                    {
                        title: "销售退货",
                        key: "payBackValue",
                        align: "right",
                        render: (h, params) => {
                            const payBackValue = params.row.payBackValue
                                ? params.row.payBackValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(payBackValue, 2, "￥")
                                )
                            ]);
                        }
                    }
                ],
                sameCompanyData: [],
                diffCompanyData: [],
                sarchCardShow: false,
                searchForm: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        init() {
            this.getSaleStatList();
        },
        onExport() {
            this.mainTable.loading = true;
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 1;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getCompanyCombineSaleStat(this.mainTable.tableSearch).then(
                res => {
                    if (res.code === 0) {
                        if (res.code === 0) {
                            let url = DOWNLOAD_SERVER + res.data.exportFileName1;
                            this.$downLoadFile(url);
                            setTimeout(() => {
                                let url2 = DOWNLOAD_SERVER + res.data.exportFileName2;
                                this.$downLoadFile(url2);
                            }, 301);
                            // window.open(FILE_SERVER + res.data.exportFileName1, "_blank");
                            // window.open(FILE_SERVER + res.data.exportFileName2, "_blank");
                        }
                    }
                    this.mainTable.loading = false;
                }
            );
        },
        onDateChange() {
            this.getSaleStatList();
        },
        getSaleStatList(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getCompanyCombineSaleStat(this.mainTable.tableSearch)
                .then(res => {
                    this.mainTable.loading = false;
                    if (res.code === 0) {
                        this.mainTable.sameCompanyData
                            = res.data.listSameCompany;
                        this.mainTable.diffCompanyData
                            = res.data.listDiffCompany;

                        let saleInAll = 0;
                        let payBackValAll = 0;

                        this.mainTable.sameCompanyData.forEach(e => {
                            saleInAll += e.saleValue;
                            payBackValAll += e.payBackValue;
                        });
                        this.mainTable.sameCompanyData.push({
                            buyerCompany: "合计",
                            saleValue: numberToFixed(saleInAll, 2),
                            payBackValue: numberToFixed(payBackValAll, 2)
                        });

                        saleInAll = 0;
                        payBackValAll = 0;
                        this.mainTable.diffCompanyData.forEach(e => {
                            saleInAll += e.saleValue;
                            payBackValAll += e.payBackValue;
                        });
                        this.mainTable.diffCompanyData.push({
                            buyerCompany: "合计",
                            saleValue: numberToFixed(saleInAll, 2),
                            payBackValue: numberToFixed(payBackValAll, 2)
                        });
                    }
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        }
    }
};
</script>

<style scoped>
</style>
